import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import clsx from "clsx";
import { Fragment } from "react/jsx-runtime";

export interface DropdownProps extends DropdownMenu.DropdownMenuProps {
  triggerContent: JSX.Element;
  children: JSX.Element;
  disablePortal?: boolean;
  className?: string;
}

export const Dropdown = ({
  triggerContent,
  children,
  disablePortal = false,
  className,
  ...props
}: DropdownProps) => {
  const PortalComponent = disablePortal ? Fragment : DropdownMenu.Portal;
  return (
    <DropdownMenu.Root {...props}>
      <DropdownMenu.Trigger asChild>
        <button className={clsx("IconButton", className)}>
          {triggerContent}
        </button>
      </DropdownMenu.Trigger>

      <PortalComponent>
        <DropdownMenu.Content className="DropdownMenuContent">
          {children}
        </DropdownMenu.Content>
      </PortalComponent>
    </DropdownMenu.Root>
  );
};
